export default function initBuscaPosts() {
    const inputsBusca = document.querySelectorAll('.js-input-busca');
    const cards = document.querySelectorAll('.c-novidades__grid .c-card-post');

    if (inputsBusca.length === 0 || cards.length === 0) return;

    function filtrarPosts(termo) {
        const termoNormalizado = termo.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        cards.forEach(card => {
            const titulo = card.querySelector('.c-card-post__title').innerText
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, "");

            if (titulo.includes(termoNormalizado)) {
                card.style.display = 'block';
                card.style.opacity = '1';
            } else {
                card.style.display = 'none';
                card.style.opacity = '0';
            }
        });
    }

    inputsBusca.forEach(input => {
        input.addEventListener('input', function() {
            const valor = this.value;

            inputsBusca.forEach(el => {
                if (el !== input) el.value = valor;
            });

            filtrarPosts(valor);
        });
    });
}